export default "__VITE_ASSET__DplHKF0T__"